import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Navigation from './component';
import { logoutUser, clearState } from '../HandleAPICalls/actions';
import { setActiveItem } from './actions';

class NavigationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
	  userPermission: '',
	  allPermission: ''
    }
  }

  close = () => {
    this.setState({
      open: false,
    });
  }

  componentDidMount() {
	const userPermission = JSON.parse(localStorage.getItem('data'));
	const allPermission = JSON.parse(localStorage.getItem('allPermissions'));
    this.setState({
	  userPermission: userPermission,
	  allPermission: allPermission
    })

   
  }

  componentDidUpdate() {
  
    console.log("removeItem---------->")
  const userPermission = JSON.parse(localStorage.getItem('data'));
	const allPermission = JSON.parse(localStorage.getItem('allPermissions'));
 
  } 

  componentDidUpdate(){
    const { open } = this.state;
  
    setTimeout(() => {
      if(open){
        window.addEventListener('click', this.close)
      }
      else{
        window.removeEventListener('click', this.close)
      }
    }, 0)
  }

  getCurrentMenu = () => {
    const pathArr = this.props.history.location.pathname.split('/');
    return pathArr[1];
  }

  handleItemClick = (e, { name }) => {
    this.props.setActiveItem(name);
    const url = `/${name.toLowerCase()}`;
    this.props.history.push(url);
    this.setState({open: false});
  }

  logout = () => {
    this.props.logoutUser();
    this.props.clearState();
    // this.props.history.push('/');
  }
  toggleMenu = () => {
    let open = !this.state.open
      this.setState({open});
  }



  render() {
    const activeItem = this.props.navigation && this.props.navigation.activeItem;
    return (
      <Navigation
        activeItem={activeItem}
        handleItemClick={this.handleItemClick}
        logout={this.logout}
        toggleMenu={this.toggleMenu}
        toggle={this.state.open}
		    userPermission={this.state.userPermission}
		    allPermission={this.state.allPermission}
      />
    );
  }
}

function mapStateToProps({ navigation }) {
  return {
    navigation,
  };
}

export default withRouter(connect(mapStateToProps,
  {
    logoutUser,
    clearState,
    setActiveItem,
  }
)(NavigationContainer));


// WEBPACK FOOTER //
// ./src/Modules/Navigation/container.jsx